import { cloneElement, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router';

import { useCurrentUser } from 'my-core/hooks';
import { pathToString, studentSignupPath } from 'my-core/routes';

import { toggleLoginForm } from 'my-actions/AppStateActions';

function LoginProtected(props) {
  const {
    actionText,
    checkout,
    children,
    login,
    messagingProduct,
    messagingType,
    onClick,
    prompt,
    redirect,
    source,
    toSignupPage,
    ...rest
  } = props;

  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const location = useLocation();

  const showLoginPrompt = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();

      dispatch(
        toggleLoginForm({
          actionText,
          messagingProduct,
          messagingType,
          prompt,
          redirect: redirect && pathToString(redirect),
          source,
          page: login ? 'login' : 'signup',
        }),
      );
      onClick?.(e);
    },
    [dispatch, login, onClick, actionText, messagingProduct, messagingType, prompt, redirect, source],
  );

  if (!currentUser.guest) return children;

  if (toSignupPage) {
    return cloneElement(children, {
      ...rest,
      component: Link,
      to: studentSignupPath({
        redirect: pathToString(redirect || location),
        actionText,
        msgType: messagingType,
        prompt,
        product: messagingProduct,
        checkout,
        ...toSignupPage,
      }),
      onClick: onClick,
      target: '_self',
    });
  }
  return cloneElement(children, { ...rest, ...(children.props.to && { to: '#' }), onClick: showLoginPrompt });
}

export default LoginProtected;
